(() => {
  if (window.__stoneLocalizationInitialized) return;
  window.__stoneLocalizationInitialized = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const button = event.submitter;
    const stoneUrl = form.dataset?.stoneLocalizationUrl;

    if (event.defaultPrevented || !stoneUrl || button?.form !== form || button.name !== 'locale_code') return;

    const roots = [...form.querySelectorAll('[data-language-root-url]')]
      .map((option) => option.dataset.languageRootUrl)
      .filter((root) => typeof root === 'string' && root.startsWith('/') && !root.startsWith('//'))
      .map((root) => root.replace(/\/+$/, ''))
      .sort((a, b) => b.length - a.length);
    const targetRoot = button.dataset.languageRootUrl?.replace(/\/+$/, '');

    if (!roots.includes(targetRoot)) return;

    const stripRoot = (path) => {
      const root = roots.find((value) => value && path.startsWith(`${value}/`));
      return root ? path.slice(root.length) : path;
    };
    const sourceUrl = new URL(stoneUrl, window.location.origin);
    const currentUrl = new URL(window.location.href);

    if (sourceUrl.origin !== currentUrl.origin) return;

    const sourcePath = stripRoot(sourceUrl.pathname).replace(/\/$/, '');
    const basePath = sourcePath.slice(0, sourcePath.lastIndexOf('/') + 1);
    const currentPath = stripRoot(currentUrl.pathname);
    const stoneHandle = currentPath.slice(basePath.length).replace(/\/$/, '');

    if (!currentPath.startsWith(basePath) || !stoneHandle || stoneHandle.includes('/')) return;

    currentUrl.pathname = `${targetRoot}${currentPath}`;
    event.preventDefault();
    window.location.assign(currentUrl.href);
  }, true);
})();
